import { MessageCircle } from "lucide-react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CONTACT } from "../content";
import { useLang } from "../LanguageContext";

export const Layout = () => {
  const { t } = useLang();
  const waHref = `https://wa.me/${CONTACT.reserveWa}?text=${encodeURIComponent(t.reserve2.waTemplate)}`;
  return (
    <>
      <div className="grain" aria-hidden="true" />
      <div className="App relative bg-ivory">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp"
          aria-label="WhatsApp"
          className="fixed bottom-6 right-6 z-50 bg-olive text-ivory h-14 w-14 rounded-full flex items-center justify-center shadow-lg shadow-brown/20 transition-[background-color,transform] duration-300 hover:bg-brown hover:-translate-y-0.5"
        >
          <MessageCircle size={26} strokeWidth={1.8} />
        </a>
      </div>
    </>
  );
};
